import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { TabellaDifferenzeCardItem as Original } from 'components/molecules'
import {
  TabellaDifferenzeCardItemSettings,
  TabellaDifferenzeCardItemFloatingSettings,
} from './TabellaDifferenzeCardItemSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getIcon } from '@utils/icons'

export const defaultProps = {
  icon: '',
}

export const tabellaDifferenzeCardItemItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
  iconLeft: getIcon(blockProps.icon),
})

export const dynamicProps = []

export const TabellaDifferenzeCardItem: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-tabella-differenze-card-item ${props.className}`}
      >
        <Original
          item={tabellaDifferenzeCardItemItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

TabellaDifferenzeCardItem.craft = withCraft({
  name: 'TabellaDifferenzeCardItem',
  defaultProps: defaultProps,
  settings: TabellaDifferenzeCardItemSettings,
  floatingSettings: TabellaDifferenzeCardItemFloatingSettings,
})
